<template>
  <div>
    <div class="main" :class="{ focused: isFocusedView }">
      <p class="title">개인정보취급방침</p>
      <div class="text-box" v-if="termsData">
        <!-- <textarea
          readonly
          class="terms-area"
          v-model="termsData[0].content"
          disabled="disabled"
          ref="textBox"
        ></textarea> -->
        <div class="terms-area" ref="textBox" v-html="termsData">
        </div>
        <button
          class="scroll-up"
          :class="{ focused: focusIndex === 0 }"
          @click="scrollUp"
          @mouseover="focusIndex = 0"
        >
          <img src="@/assets/scroll-up-ic-u.png" class="img-u" />
          <img src="@/assets/scroll-up-ic-f.png" class="img-f" />
        </button>
        <button
          class="scroll-down"
          :class="{ focused: focusIndex === 1 }"
          @click="scrollDown"
          @mouseover="focusIndex = 1"
        >
          <img src="@/assets/scroll-down-ic-u.png" class="img-u" />
          <img src="@/assets/scroll-down-ic-f.png" class="img-f" />
        </button>
      </div>
      <button
        class="exit-botton"
        :class="{ focused: focusIndex === 2 }"
        @click="backKeyProc"
        @mouseover="focusIndex = 2"
        ref="exit"
      >
        나가기
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActiveVue: true,
      focusIndex: 2,
      maxIndex: 2,
      scrollRange: 490,
    };
  },
  computed: {
    keyInput() {
      return this.$store.getters.keyInput;
    },
    fousedView() {
      return this.$store.getters.focusedView;
    },
    termsData() {
      // return this.$store.getters.terms;
      return this.$store.getters.terms[0]?.content.replace(/\n/gi, "<br>");
    },
    isFocusedView() {
      return this.fousedView === "default";
    },
  },

  watch: {
    keyInput(val, oldVal) {
      if (this.isActiveVue && val.focusView == "default") {
        switch (val.key) {
          case "ArrowLeft":
            this.leftKeyProc(val);
            break;
          case "ArrowRight":
            this.rightKeyProc(val);
            break;
          case "ArrowUp":
            this.upKeyProc(val);
            break;
          case "ArrowDown":
            this.downKeyProc(val);
            break;
          case "Enter":
            this.enterKeyProc(val);
            break;
          case "Backspace":
            this.backKeyProc(val);
            break;
        }
      }
    },
  },

  methods: {
    leftKeyProc(keyInput) {
      this.$store.commit("SET_FOCUSED_VIEW", "gnb");
    },
    upKeyProc(keyInput) {
      if (this.focusIndex > 0) {
        --this.focusIndex;
      }
    },
    downKeyProc(keyInput) {
      if (this.focusIndex < this.maxIndex) {
        ++this.focusIndex;
      }
    },
    enterKeyProc(keyInput) {
      switch (this.focusIndex) {
        case 0:
          this.scrollUp();
          break;
        case 1:
          this.scrollDown();
          break;
        case 2:
          this.backKeyProc();
          break;
      }
    },
    backKeyProc(keyInput) {
      this.$router.go(-1);
    },
    scrollUp() {
      let scrollPosition = this.$refs.textBox.scrollTop - this.scrollRange;
      if (scrollPosition < 0) {
        scrollPosition = 0;
      }
      this.$refs.textBox.scrollTop = scrollPosition;
    },
    scrollDown() {
      let scrollPosition = this.$refs.textBox.scrollTop + this.scrollRange;
      if (scrollPosition < this.$refs.textBox.scrollHeight) {
        this.$refs.textBox.scrollTop = scrollPosition;
      }
    },
  },
  created() {
    this.$progress.$emit("on:progress");

    this.$store
      .dispatch("FETCH_TERMS", "3")
      .then((response) => {
        this.$progress.$emit("off:progress");
      })
      .catch((error) => {
        this.$progress.$emit("off:progress");
      });
  },
  mounted() {
    if(Number(window.innerWidth) <= 1280) this.scrollRange = 200
  },
  activated() {
    this.isActiveVue = true;
  },
  deactivated() {
    this.isActiveVue = false;
  },
};
</script>

<style scoped >
.main {
  left: 176px;
  top: 198px;
}
.title {
  font-size: 56px;
  color: #eeeeee;
}
.text-box {
  width: 1704px;
  height: 560px;
  margin: 40px 0;
  background-color: #191919;
}
button {
  border: none;
}
.focused .exit-botton.focused {
  border: solid 4px #eeeeee;
}
button img {
  position: absolute;
  left: 0;
  top: 0;
}
textarea {
  width: 1453px;
  height: 520px;
  margin: 20px 30px;
  color: #888888;
  background-color: #191919;
  font-size: 24px;
  line-height: 36px;
  overflow: auto;
  border: none;
  resize: none;
  padding-right: 177px;
}
.terms-area {
  width: 1453px;
  height: 520px;
  margin: 20px 30px;
  color: #888888;
  background-color: #191919;
  font-size: 24px;
  line-height: 36px;
  overflow: auto;
  border: none;
  resize: none;
  padding-top: 20px;
  padding-right: 177px;
}

::-webkit-scrollbar-thumb {
  height: 48px;
  background-color: #3e3e3e;
  border-radius: 0;
  /* width : 16px; */
}
::-webkit-scrollbar {
  width: 16px;
}
::-webkit-scrollbar-track {
  margin: 105px 0;
}

.scroll-up {
  position: absolute;
  top: 20px;
  right: 83px;
}
.scroll-down {
  position: absolute;
  bottom: 83px;
  right: 83px;
}
.img-f {
  display: none;
}
button.focused .img-u {
  display: none;
}
button.focused .img-f {
  display: block;
}
.exit-botton {
  width: 1704px;
  height: 80px;
  margin: 0 24px 0 0;
  background-color: #3e3e3e;
  font-size: 28px;
  text-align: center;
  color: #eeeeee;
  border: none;
}

@media all and (min-width:0px) and (max-width:1280px){
  .main {
    width: 1128px;
    left: 120px;
    top: 120px;
  }
  .title {
    font-size: 40px;
    font-weight: bold;
    color: #ffffff;
  }

  .text-box {
    width: 1128px;
    height: 352px;
    margin: 40px 0 32px;
    background-color: #191919;
    padding: 16px 16px;
    position: relative;
  }

  .terms-area {
    width: 1044px;
    height: 320px;
    margin: 0;
    color: #888888;
    background-color: #191919;
    font-size: 16px;
    line-height: 1.5;
    overflow: auto;
    border: none;
    resize: none;
    padding-top: 0px;
    padding-right: 40px;
    box-sizing: content-box;
  }

  ::-webkit-scrollbar-thumb {
    height: 40px;
    background-color: #979797;
    border-radius: 0;
  }
  ::-webkit-scrollbar-track {
    background-color: #3e3e3e;
  }
  ::-webkit-scrollbar {
    width: 8px;
  }
  ::-webkit-scrollbar-track {
    margin: 52px 0;
  }

  .scroll-up {
    position: absolute;
    top: 12px;
    right: 52px;
  }

  .scroll-down {
    position: absolute;
    bottom: 52px;
    right: 52px;
  }
  
  img {
    width: 40px;
    height: 40px;
  }

  .exit-botton {
    width: 1128px;
    height: 56px;
    background-color: #3e3e3e;
    font-size: 18px;
    text-align: center;
    color: #ffffff;
    font-weight: bold;
    border: none;
  }

  .focused .exit-botton.focused {
    border: solid 3px #ffffff;
  }
}
</style>